import React, { FC } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useGlobalState } from '../../../MeetContext/MeetContext';
import '../Meeting.scss';



const Dialogbox: FC = ( ) => {
    const {dialogOpen, setDialogOpen, startScreenShare, presenter, setOpenShareScreenPopup} = useGlobalState();

    const handleScreenShareClick = () => { 
        setDialogOpen(false); 
        if (window.electron && window.electron.isElectron()) {
            setOpenShareScreenPopup(true);
        }
        else {
            startScreenShare();
        }
    }

    return(
        <Dialog open={dialogOpen} className='dialog-box' sx={{}}>
            <DialogContent className='dialog-content-main' sx={{width: '20rem'}}>
                <DialogContentText sx={{fontSize: '18px'}}>
                    This will let you take over from 
                </DialogContentText>
                <DialogContentText sx={{fontSize: '18px'}}>
                    {presenter?.userName} as the main presenter
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{margin:"5px"}}>
                <Button className='closeBtnStyle' onClick={() => setDialogOpen(false)} variant="outlined">Cancel</Button>
                <Button className='btnStyle' onClick={() => handleScreenShareClick()} variant="contained">Share now</Button>
            </DialogActions>
        </Dialog>
    )
}

export default Dialogbox;